/**
 * 判断是否 十六进制颜色值.
 * 输入形式可为 #fff000 #f00
 *
 * @param   String  color   十六进制颜色值
 * @return  Boolean
 */
export const isHexColor = (color: string) => {
  const reg = /^#([0-9a-fA-F]{3}|[0-9a-fA-f]{6})$/
  return reg.test(color)
}

/**
 * RGB 颜色值转换为 十六进制颜色值.
 * r, g, 和 b 需要在 [0, 255] 范围内
 *
 * @return  String          类似#ff00ff
 * @param r
 * @param g
 * @param b
 */
export const rgbToHex = (r: number, g: number, b: number) => {
  // tslint:disable-next-line:no-bitwise
  const hex = ((r << 16) | (g << 8) | b).toString(16)
  return '#' + new Array(Math.abs(hex.length - 7)).join('0') + hex
}

/**
 * Transform a HEX color to its RGB representation
 * @param {string} hex The color to transform
 * @returns The RGB representation of the passed color
 */
export const hexToRGB = (hex: string, opacity?: number) => {
  let sHex = hex.toLowerCase()
  if (isHexColor(hex)) {
    if (sHex.length === 4) {
      let sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sHex.slice(i, i + 1).concat(sHex.slice(i, i + 1))
      }
      sHex = sColorNew
    }
    const sColorChange: number[] = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sHex.slice(i, i + 2)))
    }
    return opacity
      ? 'RGBA(' + sColorChange.join(',') + ',' + opacity + ')'
      : 'RGB(' + sColorChange.join(',') + ')'
  }
  return sHex
}

export const colorIsDark = (color: string) => {
  if (!isHexColor(color)) return
  const [r, g, b] = hexToRGB(color)
    .replace(/(?:\(|\)|rgb|RGB)*/g, '')
    .split(',')
    .map((item) => Number(item))
  return r * 0.299 + g * 0.578 + b * 0.114 < 192
}

/**
 * Darkens a HEX color given the passed percentage
 * @param {string} color The color to process
 * @param {number} amount The amount to change the color by
 * @returns {string} The HEX representation of the processed color
 */
export const darken = (color: string, amount: number) => {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color
  amount = Math.trunc((255 * amount) / 100)
  return `#${subtractLight(color.substring(0, 2), amount)}${subtractLight(
    color.substring(2, 4),
    amount
  )}${subtractLight(color.substring(4, 6), amount)}`
}

/**
 * Lightens a 6 char HEX color according to the passed percentage
 * @param {string} color The color to change
 * @param {number} amount The amount to change the color by
 * @returns {string} The processed color represented as HEX
 */
export const lighten = (color: string, amount: number) => {
  color = color.indexOf('#') >= 0 ? color.substring(1, color.length) : color
  amount = Math.trunc((255 * amount) / 100)
  return `#${addLight(color.substring(0, 2), amount)}${addLight(
    color.substring(2, 4),
    amount
  )}${addLight(color.substring(4, 6), amount)}`
}

/* Suma el porcentaje indicado a un color (RR, GG o BB) hexadecimal para aclararlo */
/**
 * Sums the passed percentage to the R, G or B of a HEX color
 * @param {string} color The color to change
 * @param {number} amount The amount to change the color by
 * @returns {string} The processed part of the color
 */
const addLight = (color: string, amount: number) => {
  const cc = parseInt(color, 16) + amount
  const c = cc > 255 ? 255 : cc
  return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
}

/**
 * Calculates luminance of an rgb color
 * @param {number} r red
 * @param {number} g green
 * @param {number} b blue
 */
const luminanace = (r: number, g: number, b: number) => {
  const a = [r, g, b].map((v) => {
    v /= 255
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  })
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722
}

/**
 * Calculates contrast between two rgb colors
 * @param {string} rgb1 rgb color 1
 * @param {string} rgb2 rgb color 2
 */
const contrast = (rgb1: string[], rgb2: number[]) => {
  return (
    (luminanace(~~rgb1[0], ~~rgb1[1], ~~rgb1[2]) + 0.05) /
    (luminanace(rgb2[0], rgb2[1], rgb2[2]) + 0.05)
  )
}

/**
 * Determines what the best text color is (black or white) based con the contrast with the background
 * @param hexColor - Last selected color by the user
 */
export const calculateBestTextColor = (hexColor: string) => {
  const rgbColor = hexToRGB(hexColor.substring(1))
  const contrastWithBlack = contrast(rgbColor.split(','), [0, 0, 0])

  return contrastWithBlack >= 12 ? '#000000' : '#FFFFFF'
}

// 白色系
export const setWhiteColor = () => {
  const el = document.documentElement
  // 获取 css 变量
  getComputedStyle(el).getPropertyValue(`--el-color-primary`)
  // 设置 css 变量
  el.style.setProperty('--el-color-primary', '#008cd6')
  // el.style.setProperty('--left-menu-text-color', '#5AC8FA')
  el.style.setProperty('--el-color-primary', '#008cd6')
  // el.style.setProperty('--left-menu-text-color', '#5AC8FA')
  el.style.setProperty('--dark-bg', '#e6e6e6')
  el.style.setProperty('--power-dark-bg', '#ffffff')
  el.style.setProperty('--power-date-color', '#ffffff')
  el.style.setProperty('--power-dialog-bg', '#ffffff')
  el.style.setProperty('--power-dialog-table-bg', '#ffffff')
  el.style.setProperty('--power-btn-normal-bg', '#f6f6f6')
  el.style.setProperty('--power-btn-normal-bg-1', '#008CD6')
  el.style.setProperty('--power-btn-active-bg', '#e5f6ff')

  el.style.setProperty('--power-btn-cancel-bg', '#E1E1E1')
  el.style.setProperty('--power-btn-cancel-font-color', '#FFFFFF')
  el.style.setProperty('--power-btn-confirm-bg', '#008CD6')
  el.style.setProperty('--power-btn-confirm-font-color', '#FFFFFF')

  el.style.setProperty('--power-divider-vertical', '#C8C8C8')

  /*滚动条颜色设置*/
  /*滚动条里面小方块*/
  el.style.setProperty('--webkit-scrollbar-thumb', '#c5c5c5')
  /*滚动条里面轨道*/
  el.style.setProperty('--webkit-scrollbar-track', '#ededed')

  el.style.setProperty('--el-table-row-hover-bg-color-self', '#f5f7fa')
  // el.style.setProperty('--xingHe-test', 'transparent')
  el.style.setProperty('--top-dark-bg', '#f0f0f0')
  el.style.setProperty('--table-border', '#006296')
  el.style.setProperty('--card-bg', '#ffffff')
  el.style.setProperty('--card-border', '#e1e1e1')
  el.style.setProperty('--title-color', '#515a6e')
  el.style.setProperty('--tree-font-color', '#515a6e')
  el.style.setProperty('--select-font-color', '#515a6e')
  el.style.setProperty('--button-bg', '#008cd6')
  el.style.setProperty('--btn-font-color', '#ffffff')
  // el.style.setProperty('--box-shadow', 'unset')
  // el.style.setProperty('--border-radius', 'unset')
  el.style.setProperty('--border-bg', 'unset')
  el.style.setProperty('--check-bg', '#409eff')
  el.style.setProperty('--page-color', '#515a6e')
  // el.style.setProperty('--btn-test-color', '#85969b')
  el.style.setProperty('--selected-cell-color', '#dcdfe6')
  el.style.setProperty('--table-hover-color', '#fafafa')
  el.style.setProperty('--popper-color', '#515a6e')
  el.style.setProperty('--el-header-bg', '#fafafa')
  el.style.setProperty('--transparent-inDark', '#ffffff')
  el.style.setProperty('--border-input', 'unset')
  el.style.setProperty('--box-shadow-light', '#dcdfe6')
  el.style.setProperty('--tree-node-icon', '#a8abb2')
  el.style.setProperty('--status-btn-bg-on', '#e3f0d3')
  el.style.setProperty('--status-btn-span-on', '#73b725')
  el.style.setProperty('--status-btn-bd-on', '#73b725')
  el.style.setProperty('--status-btn-bg-off', '#ffd6d6')
  el.style.setProperty('--status-btn-span-off', '#ce2f2f')
  el.style.setProperty('--status-btn-bd-off', '#ce2f2f')
  el.style.setProperty('--status-btn-bg-un', '#e1e1e1')
  el.style.setProperty('--status-btn-span-un', '787878')
  el.style.setProperty('--status-btn-bd-un', '#787878')
  el.style.setProperty('--tree-hover', '#ffffff')
  el.style.setProperty('--select-hover', '#E8F7FE')
  el.style.setProperty('--tree-border-color', '#dcdfe6')
  el.style.setProperty('--table-thead-color', '#787878')
  el.style.setProperty('--table-tbody-color', '#323233')
  el.style.setProperty('--page-total-color', '#787878')
  el.style.setProperty('--checkbox-border-color', '#383838')
  el.style.setProperty('--checkbox-back-color', '#fff')
  el.style.setProperty('--check-icon-color', '#fff')
  el.style.setProperty('--split-border-color', '#C5C5C5')
  el.style.setProperty('--eco-card-bg', '#fafafa')
  el.style.setProperty('--eco-col-bg', '#fff')
  el.style.setProperty('--eco-button-color', '#ADADAD')
  el.style.setProperty('--eco-button-bg', '#F6F6F6')
  el.style.setProperty('--eco-cascader-border', 'rgba(200, 200, 200, 1)')
  el.style.setProperty('--eco-cascsder-tooltip-bg', '#fff')
  el.style.setProperty('--eco-tooltip-bg', 'rgba(50, 50, 51, 1)')
  el.style.setProperty('--eco-tooltip-color', 'rgba(255, 255, 255, 1)')
  el.style.setProperty('--eco-button-select-color', '#008CD6')
  el.style.setProperty('--eco-button-select-bg', '#C6E6F9')
  el.style.setProperty('--eco-pagination-bg', '#ededed')
  el.style.setProperty('--eco-kpi-region-bg', '#E2E2E2')
  el.style.setProperty('--eco-kpi-name-light', '#F7F7F7')
  el.style.setProperty('--eco-kpi-name-dark', '#ECECEC')
  el.style.setProperty('--eco-kpi-name-white', '#fff')
  el.style.setProperty('--eco-kpi-bg', '#fff')
  el.style.setProperty('--eco-kpi-son-bg', '#F7F7F7')
  el.style.setProperty('--eco-input-hover-bg', '#c0c4cc')
  el.style.setProperty('--eco-s3-bg', '#fafafa')
  el.style.setProperty('--eco-date-picker-border', '#fff')
  el.style.setProperty('--eco-date-picker-bg', '#fff')
  el.style.setProperty('--eco-date-picker-color', '#323233')
  el.style.setProperty('--eco-date-picker-range-bg', '#e8f3ff')
  el.style.setProperty('--eco-date-picker-range-color', '#323233')
  el.style.setProperty('--eco-checkbox-color', '#606266')
  el.style.setProperty('--border-top', '#e6e6e6')
  el.style.setProperty('--loss-title', '#323233')
  el.style.setProperty('--new-button-bg', '#c6e6f9')
  el.style.setProperty('--new-button-text', '#008cd6')
  el.style.setProperty('--new-onActive-button-bg', '#f6f6f6')
  el.style.setProperty('--new-onActive-button-text', '#c5c5c5')
  el.style.setProperty('--eco-meter-bg', '#f5f5f5')
  el.style.setProperty('--eco-scroll-bg', '#c5c5c5')
  el.style.setProperty('--eco-custom-bg', '#ededed')
  el.style.setProperty('--eco-custom-color', '#787878')
  el.style.setProperty('--table-head-color', '#787878')
  el.style.setProperty('--eco-meter-split', '#006296')
  el.style.setProperty('--eco-time-split', '#ebeef5')
  el.style.setProperty('--eco-time-footer-border', '#e4e7ed')
  el.style.setProperty('--eco-drawer-bg', '#fff')
  el.style.setProperty('--eco-drawer-border', '#c8c8c8')
  el.style.setProperty('--eco-drawer-tree', '#fafafa')
  el.style.setProperty('--eco-drawer-region-bg', '#EDEDED')
  el.style.setProperty('--eco-button-cancel', '#E1E1E1')
  el.style.setProperty('--eco-type-bg', '#E1E1E1')
  el.style.setProperty('--eco-input-bg', '#fafafa')
  el.style.setProperty('--eco-green-text', '#00B900')
  el.style.setProperty('--eco-rank-red', '#DF001A')
  el.style.setProperty('--eco-button-disabled', '#c8c8c8')
  el.style.setProperty('--eco-interface-title', '#ececec')
  el.style.setProperty('--eco-tag-bg', '#f0f0f0')
  el.style.setProperty('--eco-checkbox-label', '#323233')
  el.style.setProperty('--eco-light-hover-bg', '#e1e1e1')
  el.style.setProperty('--eco-light-hover-border', '#c8c8c8')
  el.style.setProperty('--eco-light-active-bg', '#E5F6FF')
  el.style.setProperty('--eco-greenE-color', '#999999')
  el.style.setProperty('--eco-kpi-table-th', '#323233')
  el.style.setProperty('--eco-overview-CO2', '#787878')
  el.style.setProperty('--eco-interface-light', '#008CD6')
  el.style.setProperty('--eco-improve-completed', '#73B725')
  el.style.setProperty('--eco-improve-notStarted', '#787878')
  el.style.setProperty('--eco-improve-reformation', '#008CD6')
  el.style.setProperty('--eco-improve-table', '#F1F1F1')
  el.style.setProperty('--eco-improve-content', '#fff')
  el.style.setProperty('--eco-close-icon-color', '#008CD6')
  el.style.setProperty('--eco-close-icon-bg', '#E5F6FF')
  el.style.setProperty('--eco-energy-table', '#EDEDED')
  el.style.setProperty('--eco-report-table-color', '#323233')
  el.style.setProperty('--eco-el-scroll', 'rgba(50, 50, 51, 0.4)')
  el.style.setProperty('--eco-param-color', '#fff')
  el.style.setProperty('--eco-table-header-bg', '#EDEDED')
  el.style.setProperty('--eco-table-header-color', 'rgba(50, 50, 51, 1)')
  el.style.setProperty('--eco-table-even-bg', '#fff')
  el.style.setProperty('--eco-table-odd-bg', '#fafafa')
  el.style.setProperty('--eco-noData-color', '#C8C8C8')
  el.style.setProperty('--eco-drawer-header-color', ' #323233')
  el.style.setProperty('--eco-drawer-body-color', 'rgba(120, 120, 120, 1)')
  el.style.setProperty('--eco-cancel-btn-color', '#fff')
  el.style.setProperty('--eco-cancel-btn-bg', '#787878')
  el.style.setProperty('--eco-ok-btn-color', '#fff')
  el.style.setProperty('--eco-ok-btn-bg', '#008CD6')
  el.style.setProperty('--eco-ok-btn-disabled-color', '#fff')
  el.style.setProperty('--eco-ok-btn-disabled-bg', '#C6E6F9')
  el.style.setProperty('--eco-input-normal-border', '#C8C8C8')
  el.style.setProperty('--eco-input-abnormal-color', '#CE2F2F')
  el.style.setProperty('--eco-input-normal-bg', '#FFF')
  el.style.setProperty('--eco-input-normal-color', '#323233')
  el.style.setProperty('--eco-border-color', '#c8c8c8')
  el.style.setProperty('--eco-table-body-bg', '#FAFAFA')
  el.style.setProperty('--eco-input-placeholder', '#C8C8C8')
  el.style.setProperty('--eco-time-disabled', '#fff')
  el.style.setProperty('--eco-fixed-table-odd', '#FAFAFA')
  el.style.setProperty('--eco-fixed-table-even', '#FFF')
  el.style.setProperty('--eco-fixed-table-header', '#EDEDED')
  el.style.setProperty('--eco-disabled-text', '#E1E1E1')
  el.style.setProperty('--eco-total-title', '#555')
  el.style.setProperty('--eco-table-sort-icon', '#C6E6F9')
  el.style.setProperty('--eco-time-button', '#E5F6FF')
  el.style.setProperty('--eco-drawer-table-odd', '#fafafa')
  el.style.setProperty('--eco-drawer-table-even', '#fff')
  el.style.setProperty('--eco-fixed-table-hover', '#e1e1e1')
  el.style.setProperty('--eco-fixed-table-active', '#E5F6FF')
  el.style.setProperty('--eco-room-title', '#555')
  el.style.setProperty('--eco-room-thead-title', '#787878')
  el.style.setProperty('--eco-room-tbody-title', '#787878')
  el.style.setProperty('--eco-room-table-bg', '#fafafa')
  el.style.setProperty('--eco-room-table-odd', '#fafafa')
  el.style.setProperty('--eco-room-table-even', '#fff')
  el.style.setProperty('--eco-capacity-table-even', '#EDEDED')
  el.style.setProperty('--eco-sharing-prompt-color', '#2A9ED7')

  el.style.setProperty('--hvac-date-list-select-tag-bg', '#ebebeb')
  el.style.setProperty('--hvac-card-title-stress', '#006EE6')
  el.style.setProperty('--hvac-card-bg', '#f5f5f5')
  el.style.setProperty('--hvac-card-border', '#dfdfdf')
  el.style.setProperty('--hvac-card-border-dashed', '#999999')
  el.style.setProperty('--hvac-card-border-dark', '#E6E6E6')
  el.style.setProperty('--hvac-card-border-light', '#c8c8c8')
  el.style.setProperty('--hvac-card-border-op', '#E6E6E6')
  el.style.setProperty('--hvac-card-border-op-2', '#E6E6E6')
  el.style.setProperty('--hvac-card-border-op-3', 'rgba(230, 230, 230, 0.5)')
  el.style.setProperty('--hvac-disabled-text', 'rgba(0, 0, 0, 0.25)')
  el.style.setProperty('--hvac-calendar-today-bg', '#DCF0FA')
  el.style.setProperty('--hvac-header-btn-color', '#9FA7B7')
  el.style.setProperty('--hvac-header-btn-bg', '#EDEDED')
  el.style.setProperty('--hvac-header-btn-disabled-color', '#008CD6')
  el.style.setProperty('--hvac-header-btn-disabled-bg', '#E5F6FF')
  el.style.setProperty('--hvac-header-btn-icon-color', '#9FA7B7')
  el.style.setProperty('--hvac-dialog-mask', 'rgba(50, 50, 51, 0.5)')
  el.style.setProperty('--hvac-iframe-bg', '#fafafa')
  el.style.setProperty('--hvac-btn-text-disabled', '#c8c8c8')
  el.style.setProperty('--hvac-table-fixed-column-bg', '#e6e6e6')
  el.style.setProperty('--hvac-table-fixed-header-bg', '#f5f5f5')
  el.style.setProperty('--hvac-table-title-text', '#323233')
  el.style.setProperty('--hvac-table-header', '#F5F5F5')
  el.style.setProperty('--hvac-colunm-first', '#E5E5E5')
  el.style.setProperty('--hvac-row-all', '#DCF0FA')
  el.style.setProperty('--hvac-text-sum', '#006296')
  el.style.setProperty('--hvac-table-text-color', '#323233')
  el.style.setProperty('--hvac-table-even-color', '#FFFFFF')
  el.style.setProperty('--hvac-table-border-color', '#C8C8C8')
  el.style.setProperty('--hvac-header-border-bottom', '#006296')
  el.style.setProperty('--hvac-header-border-top', '#C8C8C8')
  el.style.setProperty('--hvac-radio-color', '#787878')
  el.style.setProperty('--hvac-title-body-bgColor', '#fafafa')
  el.style.setProperty('--hvac-table-header-border', '#006296')
  el.style.setProperty('--hvac-card-header-bg', '#f0f0f0')
  el.style.setProperty('--hvac-list-select-bg', '#e5f6ff')
  el.style.setProperty('--hvac-common-btn-border', '#008CD6')
  el.style.setProperty('--hvac-common-btn-bg', 'transparent')
  el.style.setProperty('--hvac-common-btn-color', '#008CD6')
  el.style.setProperty('--hvac-info-btn-bg', '#f0f0f0')
  el.style.setProperty('--hvac-icon-light', '#ffffff')
  el.style.setProperty('--hvac-content-bg', '#fafafa')
  el.style.setProperty('--hvac-table-header-bg', '#fafafa')
  el.style.setProperty('--hvac-table-header-color', '#787878')
  el.style.setProperty('--hvac-table-body-tr-border', '#C8C8C8')
  el.style.setProperty('--hvac-icon-color', '#008CD6')
  el.style.setProperty('--hvac-dialog-subItem-bg', '#ffffff')
  el.style.setProperty('--hvac-form-label-color', '#787878')
  el.style.setProperty('--hvac-form-input-color', '#555')
  el.style.setProperty('--hvac-input-placeholder', '#C8C8C8')
  el.style.setProperty('--hvac-icon-star', '#CE2F2F')
  el.style.setProperty('--hvac-tab-border-color', '#fff')
  el.style.setProperty('--hvac-btn-confirm-color', '#FFF')
  el.style.setProperty('--hvac-btn-confirm-bg', '#008CD6')
  el.style.setProperty('--hvac-btn-color', '#FFFFFF')
  el.style.setProperty('--hvac-btn-bg', '#008CD6')
  el.style.setProperty('--hvac-btn-hover-color', '#008CD6')
  el.style.setProperty('--hvac-btn-hover-bg', '#C6E6F9')
  el.style.setProperty('--hvac-dialog-footer-bg', '#FFF')
  el.style.setProperty('--hvac-icon-disabled-color', '#C6E6F9')
  el.style.setProperty('--hvac-btn-add-color', '#FFF')
  el.style.setProperty('--hvac-table-body-cell-color', '#555')
  el.style.setProperty('--hvac-table-body-tr-odd', '#fff')
  el.style.setProperty('--hvac-checkbox-inner-line', '#fff')
  el.style.setProperty('--hvac-cascader-tag', '#f0f2f5')
  el.style.setProperty('--hvac-cascader-tag-color', '#909399')
  el.style.setProperty('--hvac-cascader-arrow-bg', '#fff')
  el.style.setProperty('--hvac-cascader-menu-item-color', '#323233')
  el.style.setProperty('--hvac-cascader-menu-split-line', '#e4e7ed')
  el.style.setProperty('--hvac-checkbox-inner-bg', '#fff')
  el.style.setProperty('--hvac-scrollbar-thumb-bg', 'rgba(50, 50, 51, 0.4)')
  el.style.setProperty('--hvac-scrollbar-thumb-border', '#fff')
  el.style.setProperty('--hvac-dialog-bg', '#FFF')
  el.style.setProperty('--hvac-dialog-shadow-color', 'rgba(50, 50, 51, 0.25)')
  el.style.setProperty('--hvac-dialog-shadow-header', '#fafafa')
  el.style.setProperty('--hvac-popper-arrow-border-color', '#e4e7ed')
  el.style.setProperty('--hvac-popper-text-color', '#FFFFFF')
  el.style.setProperty('--hvac-popper-body-bg', '#323233')
  el.style.setProperty('--hvac-search-wrapper-bg', '#F0F0F0')
  el.style.setProperty('--hvac-switch_disabled_color', '#787878')
  el.style.setProperty('--hvac-table-body-tr-border-color', '#EDEDED')
  el.style.setProperty('--hvac-el-tag-bg', '#ffffff')
  el.style.setProperty('--hvac-upload-drag-hover', '#E5F6FF')
  el.style.setProperty('--hvac-upload-drag-format-error', '#fafafa')
  el.style.setProperty('--hvac-upload-drag-format-error-span', '#323233')
  el.style.setProperty('--hvac-item-active-label', '#008CD6')
  el.style.setProperty('--hvac-item-active-border', '#008CD6')
  el.style.setProperty('--hvac-batch-import-success', '#2FCE5C')
  el.style.setProperty('--hvac-btn-cancel', '#787878')
  el.style.setProperty('--load-item-title-span', '#515a6e')
  el.style.setProperty('--load-item-card-bg', '#fafafa')
  el.style.setProperty('--load-item-tag-bg', '#fff')
  el.style.setProperty('--load-item-time-disabled', 'rgba(247, 248, 250)')
  el.style.setProperty('--hvac-orange-value-color', '#FF9300')
  el.style.setProperty('--hvac-blue-value-color', '#3DBBF9')
  el.style.setProperty('--hvac-green-value-color', '#2FCE5C')
  el.style.setProperty('--hvac-red-value-color', '#DF001A')
}

// 深蓝色
export const setDeepBlue = () => {
  const el = document.documentElement
  // const el = document.getElementById('xxx')
  // 获取 css 变量
  getComputedStyle(el).getPropertyValue(`--el-color-primary`)
  // 设置 css 变量
  el.style.setProperty(
    '--dark-bg',
    'radial-gradient(94.63% 94.63% at 50% 5.37%, #263743 0%, #000000 100%)'
  )
  // el.style.setProperty('--dark-bg', color)
  el.style.setProperty(
    '--power-dark-bg',
    'radial-gradient(94.63% 94.63% at 50% 5.37%, #263743 0%, #000000 100%)'
  )
  el.style.setProperty('--el-color-primary', '#5AC8FA')
  el.style.setProperty('--left-menu-text-color', '#fff')
  el.style.setProperty('--el-color-primary', '#5AC8FA')
  el.style.setProperty('--left-menu-text-color', '#fff')
  el.style.setProperty('--power-date-color', '#85969b')
  el.style.setProperty('--power-dialog-bg', '#17293C')
  el.style.setProperty('--power-dialog-table-bg', '#1e3146')
  el.style.setProperty('--power-btn-normal-bg', '#2B3B4B 30%')
  el.style.setProperty('--power-btn-normal-bg-1', '#5AC8FA')
  el.style.setProperty('--power-btn-active-bg', '#254251')

  el.style.setProperty('--power-btn-cancel-bg', '#3F4D5A')
  el.style.setProperty('--power-btn-cancel-font-color', '#85969B')
  el.style.setProperty('--power-btn-confirm-bg', '#5AC8FA')
  el.style.setProperty('--power-btn-confirm-font-color', '#17293C')

  el.style.setProperty('--power-divider-vertical', '#576E7D')

  /*滚动条颜色设置*/
  /*滚动条里面小方块*/
  el.style.setProperty('--webkit-scrollbar-thumb', '#51646B')
  /*滚动条里面轨道*/
  el.style.setProperty('--webkit-scrollbar-track', 'rgba(255, 255, 255, 0)')

  el.style.setProperty('--el-table-row-hover-bg-color-self', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--xingHe-test', 'transparent')
  el.style.setProperty('--top-dark-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--table-border', 'rgba(198, 230, 249, 1)')
  el.style.setProperty('--card-bg', '#141F26')
  el.style.setProperty('--card-border', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--title-color', '#ffffff')
  el.style.setProperty('--tree-font-color', '#ffffff')
  el.style.setProperty('--select-font-color', '#5AC8FA')
  el.style.setProperty('--button-bg', '#5AC8FA')
  el.style.setProperty('--btn-font-color', '#ffffff')
  el.style.setProperty('--box-shadow', 'unset')
  el.style.setProperty('--border-radius', 'unset')
  el.style.setProperty('--border-bg', '#5AC8FA')
  el.style.setProperty('--check-bg', '#5AC8FA')
  el.style.setProperty('--page-color', '#5AC8FA')
  el.style.setProperty('--btn-test-color', '#85969b')
  el.style.setProperty('--selected-cell-color', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--table-hover-color', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--popper-color', '#ffffff')
  el.style.setProperty('--el-header-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--transparent-inDark', 'transparent')
  el.style.setProperty('--border-input', 'unset')
  el.style.setProperty('--box-shadow-light', 'rgba(85, 137, 155, 0.3)')
  el.style.setProperty('--tree-node-icon', '#ffffff')
  el.style.setProperty('--status-btn-bg-on', '#233C29')
  el.style.setProperty('--status-btn-span-on', '#33C733')
  el.style.setProperty('--status-btn-bd-on', '#33C733')
  el.style.setProperty('--status-btn-bg-off', '#352529')
  el.style.setProperty('--status-btn-span-off', '#E53348')
  el.style.setProperty('--status-btn-bd-off', '#E53348')
  el.style.setProperty('--status-btn-bg-un', '#334353')
  el.style.setProperty('--status-btn-span-un', '#85969B')
  el.style.setProperty('--status-btn-bd-un', '#85969B')
  el.style.setProperty('--tree-hover', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--select-hover', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--tree-border-color', '#ffffff')
  el.style.setProperty('--table-thead-color', '#85969B')
  el.style.setProperty('--table-tbody-color', '#fff')
  el.style.setProperty('--page-total-color', '#85969B')
  el.style.setProperty('--checkbox-border-color', '#fff')
  el.style.setProperty('--checkbox-back-color', '#323233')
  el.style.setProperty('--check-icon-color', '#141F26')
  el.style.setProperty('--split-border-color', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-card-bg', '#141f26')
  el.style.setProperty('--eco-col-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-button-color', '#51646B')
  el.style.setProperty('--eco-button-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-cascader-border', 'rgba(81, 100, 107, 1)')
  el.style.setProperty('--eco-cascsder-tooltip-bg', '#17293C')
  el.style.setProperty('--eco-tooltip-bg', 'rgba(185, 193, 196, 1)')
  el.style.setProperty('--eco-tooltip-color', 'rgba(21, 29, 36, 1)')
  el.style.setProperty('--eco-button-select-color', '#5AC8FA')
  el.style.setProperty('--eco-button-select-bg', '#254251')
  el.style.setProperty('--eco-pagination-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--eco-kpi-region-bg', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--eco-kpi-name-light', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-kpi-name-dark', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-kpi-name-white', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-kpi-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-kpi-son-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-input-hover-bg', '#5AC8FA')
  el.style.setProperty('--eco-s3-bg', '#17293C')
  el.style.setProperty('--eco-date-picker-border', '#9FA7B7')
  el.style.setProperty('--eco-date-picker-bg', '#334353')
  el.style.setProperty('--eco-date-picker-color', '#9FA7B7')
  el.style.setProperty('--eco-date-picker-range-bg', '#254251')
  el.style.setProperty('--eco-date-picker-range-color', '#85969B')
  el.style.setProperty('--eco-checkbox-color', '#fff')
  el.style.setProperty('--border-top', '#141F26')
  el.style.setProperty('--loss-title', 'rgba(185, 193, 196, 1)')
  el.style.setProperty('--new-button-bg', '#254251')
  el.style.setProperty('--new-button-text', '#5AC8FA ')
  el.style.setProperty('--new-onActive-button-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--new-onActive-button-text', '#51646B')
  el.style.setProperty('--eco-meter-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-scroll-bg', '#51646B')
  el.style.setProperty('--eco-custom-bg', '#334353')
  el.style.setProperty('--eco-custom-color', '#85969B')
  el.style.setProperty('--table-head-color', '#85969B')
  el.style.setProperty('--eco-meter-split', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-time-split', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-time-footer-border', 'rgba(85, 137, 155, 0.3)')
  el.style.setProperty('--eco-drawer-bg', '#17293C')
  el.style.setProperty('--eco-drawer-border', '#51646B')
  el.style.setProperty('--eco-drawer-tree', '#212D3B')
  el.style.setProperty('--eco-drawer-region-bg', '#2B3B4B')
  el.style.setProperty('--eco-button-cancel', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--eco-type-bg', '#576E7D')
  el.style.setProperty('--eco-input-bg', '#141F26')
  el.style.setProperty('--eco-green-text', '#33C733')
  el.style.setProperty('--eco-rank-red', '#E53348')
  el.style.setProperty('--eco-button-disabled', '#334353')
  el.style.setProperty('--eco-interface-title', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--eco-tag-bg', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-checkbox-label', '#5AC8FA')
  el.style.setProperty('--eco-light-hover-bg', '#3F4D5A')
  el.style.setProperty('--eco-light-hover-border', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-light-active-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--eco-greenE-color', '#85969B')
  el.style.setProperty('--eco-kpi-table-th', '#FFFFFF')
  el.style.setProperty('--eco-overview-CO2', '#85969B')
  el.style.setProperty('--eco-interface-light', '#5AC8FA')
  el.style.setProperty('--eco-improve-completed', '#33C733')
  el.style.setProperty('--eco-improve-notStarted', '#51646B')
  el.style.setProperty('--eco-improve-reformation', '#008CD6')
  el.style.setProperty('--eco-improve-table', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-improve-content', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-close-icon-color', '#5AC8FA')
  el.style.setProperty('--eco-close-icon-bg', '#254251')
  el.style.setProperty('--eco-energy-table', 'transparent')
  el.style.setProperty('--eco-report-table-color', '#85969B')
  el.style.setProperty('--eco-el-scroll', '#51646B')
  el.style.setProperty('--eco-param-color', '#000')
  el.style.setProperty('--eco-table-header-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--eco-table-header-color', 'rgba(185, 193, 196, 1)')
  el.style.setProperty('--eco-table-even-bg', 'rgba(0, 0, 0, 0.05)')
  el.style.setProperty('--eco-table-odd-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-noData-color', '#51646B')
  el.style.setProperty('--eco-drawer-header-color', '#B9C1C4')
  el.style.setProperty('--eco-drawer-body-color', 'rgba(133, 150, 155, 1)')
  el.style.setProperty('--eco-cancel-btn-color', '#000')
  el.style.setProperty('--eco-cancel-btn-bg', '#85969B')
  el.style.setProperty('--eco-ok-btn-color', '#151D24')
  el.style.setProperty('--eco-ok-btn-bg', '#5AC8FA')
  el.style.setProperty('--eco-ok-btn-disabled-color', '#151D24')
  el.style.setProperty('--eco-ok-btn-disabled-bg', '#254251')
  el.style.setProperty('--eco-input-normal-border', 'rgba(81, 100, 107, 1)')
  el.style.setProperty('--eco-input-abnormal-color', '#E53348')
  el.style.setProperty('--eco-input-normal-bg', '#151D24')
  el.style.setProperty('--eco-input-normal-color', '#B9C1C4')
  el.style.setProperty('--eco-border-color', '#51646b')
  el.style.setProperty('--eco-table-body-bg', 'transparent')
  el.style.setProperty('--eco-input-placeholder', '#51646B')
  el.style.setProperty('--eco-time-disabled', '#17293C')
  el.style.setProperty('--eco-fixed-table-odd', '#283542')
  el.style.setProperty('--eco-fixed-table-even', '#212F39')
  el.style.setProperty('--eco-fixed-table-header', '#394953')
  el.style.setProperty('--eco-disabled-text', 'rgba(81, 100, 107, 0.60)')
  el.style.setProperty('--eco-total-title', '#9FACB0')
  el.style.setProperty('--eco-table-sort-icon', '#254251')
  el.style.setProperty('--eco-time-button', '#2B3B4B')
  el.style.setProperty('--eco-drawer-table-odd', '#1F3245')
  el.style.setProperty('--eco-drawer-table-even', '#172838')
  el.style.setProperty('--eco-fixed-table-hover', '#404E59')
  el.style.setProperty('--eco-fixed-table-active', '#2C3C4A')
  el.style.setProperty('--eco-room-title', '#B9C1C4')
  el.style.setProperty('--eco-room-thead-title', '#B9C1C4')
  el.style.setProperty('--eco-room-tbody-title', '#85969B')
  el.style.setProperty('--eco-room-table-bg', 'transparent')
  el.style.setProperty('--eco-room-table-odd', 'rgba(95, 117, 162, 0.10)')
  el.style.setProperty('--eco-room-table-even', 'rgba(0, 0, 0, 0.05)')
  el.style.setProperty('--eco-capacity-table-even', 'rgba(0, 0, 0, 0.05)')
  el.style.setProperty('--eco-sharing-prompt-color', '#8bd6fb')

  el.style.setProperty('--hvac-date-list-select-tag-bg', '#334353')
  el.style.setProperty('--hvac-card-title-stress', '#0062CC')
  el.style.setProperty('--hvac-card-bg', '#2b3b4b')
  el.style.setProperty('--hvac-card-border', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--hvac-card-border-dashed', 'rgba(133, 150, 155, 0.3)')
  el.style.setProperty('--hvac-card-border-dark', 'rgba(133, 150, 155, 0.3)')
  el.style.setProperty('--hvac-card-border-light', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--hvac-card-border-op', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--hvac-card-border-op-2', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--hvac-card-border-op-3', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--hvac-disabled-text', 'rgba(85, 137, 155, 0.3)')
  el.style.setProperty('--hvac-calendar-today-bg', '#254251')
  el.style.setProperty('--hvac-header-btn-color', '#51646B')
  el.style.setProperty('--hvac-header-btn-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-header-btn-disabled-color', '#5AC8FA')
  el.style.setProperty('--hvac-header-btn-disabled-bg', '#2B3B4B')
  el.style.setProperty('--hvac-header-btn-icon-color', '#51646B')
  el.style.setProperty('--hvac-dialog-mask', 'rgba(0, 0, 0, 0.6)')
  el.style.setProperty('--hvac-iframe-bg', '#0C1216')
  el.style.setProperty('--hvac-btn-text-disabled', '#51646b')
  el.style.setProperty('--hvac-table-fixed-column-bg', '#2B3B4B')
  el.style.setProperty('--hvac-table-fixed-header-bg', '#263542')
  el.style.setProperty('--hvac-table-title-text', '#B9C1C4')
  el.style.setProperty('--hvac-table-header', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty(
    '--hvac-colunm-first',
    'radial-gradient(94.63% 94.63% at 50% 5.37%, #263743 0%, #000000 100%)'
  )
  el.style.setProperty('--hvac-row-all', '#254251')
  el.style.setProperty('--hvac-text-sum', '#C6E6F9')
  el.style.setProperty('--hvac-table-text-color', '#B9C1C4')
  el.style.setProperty('--hvac-table-even-color', 'rgba(0, 0, 0, 0.05)')
  el.style.setProperty('--hvac-table-border-color', '#51646B')
  el.style.setProperty('--hvac-header-border-bottom', '#C6E6F9')
  el.style.setProperty('--hvac-header-border-top', '#51646B')
  el.style.setProperty('--hvac-radio-color', '#85969B')
  el.style.setProperty('--hvac-title-body-bgColor', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--hvac-table-header-border', '#C6E6F9')
  el.style.setProperty('--hvac-card-header-bg', 'linear-gradient(180deg, #24313F 0%, #141B27 100%)')
  el.style.setProperty('--hvac-list-select-bg', '#2b3b4b')
  el.style.setProperty('--hvac-common-btn-border', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-common-btn-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-common-btn-color', '#B9C1C4')
  el.style.setProperty('--hvac-info-btn-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-icon-light', '#B9C1C4')
  el.style.setProperty('--hvac-content-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--hvac-table-header-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--hvac-table-header-color', '#85969B')
  el.style.setProperty('--hvac-table-body-tr-border', '#rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-icon-color', '#5AC8FA')
  el.style.setProperty('--hvac-dialog-subItem-bg', '#151D24')
  el.style.setProperty('--hvac-form-label-color', '#85969B')
  el.style.setProperty('--hvac-form-input-color', '#9FACB0')
  el.style.setProperty('--hvac-input-placeholder', '#51646B')
  el.style.setProperty('--hvac-icon-star', '#E53348')
  el.style.setProperty('--hvac-tab-border-color', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-btn-confirm-color', '#151D24')
  el.style.setProperty('--hvac-btn-confirm-bg', '#254251')
  el.style.setProperty('--hvac-btn-color', '#151D24')
  el.style.setProperty('--hvac-btn-bg', '#5AC8FA')
  el.style.setProperty('--hvac-btn-hover-color', '#5AC8FA')
  el.style.setProperty('--hvac-btn-hover-bg', '#254251')
  el.style.setProperty('--hvac-dialog-footer-bg', '#151D24')
  el.style.setProperty('--hvac-icon-disabled-color', '#254251')
  el.style.setProperty('--hvac-btn-add-color', '#151D24')
  el.style.setProperty('--hvac-table-body-cell-color', '#9FACB0')
  el.style.setProperty('--hvac-table-body-tr-odd', '#151D24')
  el.style.setProperty('--hvac-checkbox-inner-line', '#151D24')
  el.style.setProperty('--hvac-cascader-tag', '#2B3B4B')
  el.style.setProperty('--hvac-cascader-tag-color', '#B9C1C4')
  el.style.setProperty('--hvac-cascader-arrow-bg', '#17293C')
  el.style.setProperty('--hvac-cascader-menu-item-color', '#B9C1C4')
  el.style.setProperty('--hvac-cascader-menu-split-line', 'rgba(81, 100, 107, 0.6)')
  el.style.setProperty('--hvac-checkbox-inner-bg', 'transparent')
  el.style.setProperty('--hvac-scrollbar-thumb-bg', 'rgba(185, 193, 196, 0.4)')
  el.style.setProperty('--hvac-scrollbar-thumb-border', '#151D24')
  el.style.setProperty('--hvac-dialog-bg', '#17293C')
  el.style.setProperty('--hvac-dialog-shadow-color', 'rgba(21, 29, 36, 0.25)')
  el.style.setProperty('--hvac-dialog-shadow-header', 'transparent')
  el.style.setProperty('--hvac-popper-arrow-border-color', 'transparent')
  el.style.setProperty('--hvac-popper-text-color', '#151D24')
  el.style.setProperty('--hvac-popper-body-bg', '#B9C1C4')
  el.style.setProperty(
    '--hvac-search-wrapper-bg',
    'linear-gradient(180deg, #24313F 0%, #141B27 100%)'
  )
  el.style.setProperty('--hvac-switch_disabled_color', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-table-body-tr-border-color', '#51646B')
  el.style.setProperty('--hvac-el-tag-bg', 'rgba(21, 29, 36, 1)')
  el.style.setProperty('--hvac-upload-drag-hover', '#2B3B4B')
  el.style.setProperty('--hvac-upload-drag-format-error', '#591C20')
  el.style.setProperty('--hvac-upload-drag-format-error-span', '#E53348')
  el.style.setProperty('--hvac-item-active-label', '#5AC8FA')
  el.style.setProperty('--hvac-item-active-border', '#5AC8FA')
  el.style.setProperty('--hvac-batch-import-success', '#33C733')
  el.style.setProperty('--hvac-btn-cancel', 'rgba(81, 100, 107, 0.40)')
  el.style.setProperty('--load-item-title-span', '#b9c1c4')
  el.style.setProperty('--load-item-card-bg', '#283746')
  el.style.setProperty('--load-item-tag-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--load-item-time-disabled', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--hvac-orange-value-color', '#FF9300')
  el.style.setProperty('--hvac-blue-value-color', '#64C9FA')
  el.style.setProperty('--hvac-green-value-color', '#33C733')
  el.style.setProperty('--hvac-red-value-color', '#E53348')
}

export const setCustomColor = (bodyColor, systemColor, headerTheme) => {
  const el = document.documentElement
  // const el = document.getElementById('xxx')
  // 获取 css 变量
  getComputedStyle(el).getPropertyValue(`--el-color-primary`)
  // 设置 css 变量
  // el.style.setProperty(
  //   '--dark-bg',
  //   'radial-gradient(94.63% 94.63% at 50% 5.37%, #263743 0%, #000000 100%)'
  // )
  console.log('colorIsDark(headerTheme)', colorIsDark(headerTheme))
  if (colorIsDark(headerTheme)) {
    el.style.setProperty('--left-menu-text-color', '#fff')
    el.style.setProperty('--title-color', '#fff')
  } else {
    el.style.setProperty('--left-menu-text-color', '#323233')
    el.style.setProperty('--title-color', '#323233')
  }
  el.style.setProperty('--dark-bg', bodyColor)
  el.style.setProperty('--el-color-primary', systemColor)

  el.style.setProperty('--el-color-primary', systemColor)
  el.style.setProperty('--power-date-color', '#85969b')
  if (colorIsDark(headerTheme)) {
    el.style.setProperty('--power-dialog-bg', headerTheme)
  } else {
    el.style.setProperty('--power-dialog-bg', '#ffffff')
  }
  el.style.setProperty('--power-dialog-table-bg', '#1e3146')
  el.style.setProperty('--power-btn-normal-bg', '#2B3B4B 30%')
  el.style.setProperty('--power-btn-normal-bg-1', '#5AC8FA')
  el.style.setProperty('--power-btn-active-bg', '#254251')

  el.style.setProperty('--power-btn-cancel-bg', '#3F4D5A')
  el.style.setProperty('--power-btn-cancel-font-color', '#85969B')
  el.style.setProperty('--power-btn-confirm-bg', '#5AC8FA')
  el.style.setProperty('--power-btn-confirm-font-color', '#17293C')

  el.style.setProperty('--power-divider-vertical', '#576E7D')

  /*滚动条颜色设置*/
  /*滚动条里面小方块*/
  el.style.setProperty('--webkit-scrollbar-thumb', '#51646B')
  /*滚动条里面轨道*/
  el.style.setProperty('--webkit-scrollbar-track', 'rgba(255, 255, 255, 0)')

  el.style.setProperty('--el-table-row-hover-bg-color-self', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--xingHe-test', 'transparent')
  el.style.setProperty('--top-dark-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--table-border', 'rgba(85, 137, 155, 0.3)')
  el.style.setProperty('--card-bg', bodyColor)
  el.style.setProperty('--card-border', 'rgba(63, 77, 90, 0.5)')
  // el.style.setProperty('--title-color', '#ffffff')
  el.style.setProperty('--tree-font-color', '#ffffff')
  el.style.setProperty('--select-font-color', '#5AC8FA')
  el.style.setProperty('--button-bg', '#5AC8FA')
  el.style.setProperty('--btn-font-color', '#ffffff')
  el.style.setProperty('--box-shadow', 'unset')
  el.style.setProperty('--border-radius', 'unset')
  el.style.setProperty('--border-bg', '#5AC8FA')
  el.style.setProperty('--check-bg', '#5AC8FA')
  el.style.setProperty('--page-color', '#5AC8FA')
  el.style.setProperty('--btn-test-color', '#85969b')
  el.style.setProperty('--selected-cell-color', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--table-hover-color', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--popper-color', '#ffffff')
  el.style.setProperty('--el-header-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--transparent-inDark', 'transparent')
  el.style.setProperty('--border-input', 'unset')
  el.style.setProperty('--box-shadow-light', 'rgba(85, 137, 155, 0.3)')
  el.style.setProperty('--tree-node-icon', '#ffffff')
  el.style.setProperty('--status-btn-bg-on', '#233C29')
  el.style.setProperty('--status-btn-span-on', '#33C733')
  el.style.setProperty('--status-btn-bd-on', '#33C733')
  el.style.setProperty('--status-btn-bg-off', '#352529')
  el.style.setProperty('--status-btn-span-off', '#E53348')
  el.style.setProperty('--status-btn-bd-off', '#E53348')
  el.style.setProperty('--status-btn-bg-un', '#334353')
  el.style.setProperty('--status-btn-span-un', '#85969B')
  el.style.setProperty('--status-btn-bd-un', '#85969B')
  el.style.setProperty('--tree-hover', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--select-hover', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--tree-border-color', '#ffffff')
  el.style.setProperty('--table-thead-color', '#85969B')
  el.style.setProperty('--table-tbody-color', '#fff')
  el.style.setProperty('--page-total-color', '#85969B')
  el.style.setProperty('--checkbox-border-color', '#fff')
  el.style.setProperty('--checkbox-back-color', '#323233')
  el.style.setProperty('--check-icon-color', '#141F26')
  el.style.setProperty('--split-border-color', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-card-bg', '#141f26')
  el.style.setProperty('--eco-col-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-button-color', '#51646B')
  el.style.setProperty('--eco-button-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-cascader-border', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-cascsder-tooltip-bg', bodyColor)
  el.style.setProperty('--eco-button-select-color', '#5AC8FA')
  el.style.setProperty('--eco-button-select-bg', '#254251')
  el.style.setProperty('--eco-pagination-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--eco-kpi-region-bg', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--eco-kpi-name-light', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-kpi-name-dark', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-kpi-name-white', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-kpi-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-kpi-son-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-input-hover-bg', '#5AC8FA')
  el.style.setProperty('--eco-s3-bg', '#17293C')
  el.style.setProperty('--eco-date-picker-border', '#9FA7B7')
  el.style.setProperty('--eco-date-picker-bg', '#334353')
  el.style.setProperty('--eco-date-picker-color', '#9FA7B7')
  el.style.setProperty('--eco-date-picker-range-bg', '#254251')
  el.style.setProperty('--eco-date-picker-range-color', '#85969B')
  el.style.setProperty('--eco-checkbox-color', '#fff')
  el.style.setProperty('--border-top', '#141F26')
  el.style.setProperty('--loss-title', '#fff')
  el.style.setProperty('--new-button-bg', '#254251')
  el.style.setProperty('--new-button-text', '#5AC8FA ')
  el.style.setProperty('--new-onActive-button-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--new-onActive-button-text', '#51646B')
  el.style.setProperty('--eco-meter-bg', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-scroll-bg', '#51646B')
  el.style.setProperty('--eco-custom-bg', '#334353')
  el.style.setProperty('--eco-custom-color', '#85969B')
  el.style.setProperty('--table-head-color', '#85969B')
  el.style.setProperty('--eco-meter-split', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-time-split', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-time-footer-border', 'rgba(85, 137, 155, 0.3)')
  el.style.setProperty('--eco-drawer-bg', '#17293C')
  el.style.setProperty('--eco-drawer-border', '#51646B')
  el.style.setProperty('--eco-drawer-tree', '#212D3B')
  el.style.setProperty('--eco-drawer-region-bg', '#2B3B4B')
  el.style.setProperty('--eco-button-cancel', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--eco-type-bg', '#576E7D')
  el.style.setProperty('--eco-input-bg', headerTheme)
  el.style.setProperty('--eco-green-text', '#33C733')
  el.style.setProperty('--eco-rank-red', '#E53348')
  el.style.setProperty('--eco-button-disabled', '#334353')
  el.style.setProperty('--eco-interface-title', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--eco-tag-bg', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-checkbox-label', '#5AC8FA')
  el.style.setProperty('--eco-light-hover-bg', '#3F4D5A')
  el.style.setProperty('--eco-light-hover-border', 'rgba(87, 110, 125, 0.3)')
  el.style.setProperty('--eco-light-active-bg', '#E5F6FF')
  el.style.setProperty('--eco-greenE-color', '#85969B')
  el.style.setProperty('--eco-kpi-table-th', '#FFFFFF')
  el.style.setProperty('--eco-overview-CO2', '#85969B')
  el.style.setProperty('--eco-interface-light', '#5AC8FA')
  el.style.setProperty('--eco-improve-completed', '#33C733')
  el.style.setProperty('--eco-improve-notStarted', '#51646B')
  el.style.setProperty('--eco-improve-reformation', '#008CD6')
  el.style.setProperty('--eco-improve-table', 'rgba(43, 59, 75, 0.3)')
  el.style.setProperty('--eco-improve-content', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--eco-close-icon-color', '#5AC8FA')
  el.style.setProperty('--eco-close-icon-bg', '#254251')
  el.style.setProperty('--eco-energy-table', '#EDEDED')
  el.style.setProperty('--eco-report-table-color', '#323233')
  el.style.setProperty('--eco-el-scroll', 'rgba(50, 50, 51, 0.4)')
  el.style.setProperty('--eco-param-color', '#fff')
  el.style.setProperty('--eco-table-header-bg', '#EDEDED')
  el.style.setProperty('--eco-table-even-bg', '#fff')
  el.style.setProperty('--eco-table-odd-bg', '#FAFAFA')
  el.style.setProperty('--eco-disabled-text', '#E1E1E1')
  el.style.setProperty('--eco-total-title', '#555')
  el.style.setProperty('--eco-table-sort-icon', '#C6E6F9')
  el.style.setProperty('--eco-time-button', '#E5F6FF')
  el.style.setProperty('--eco-drawer-table-odd', '#fafafa')
  el.style.setProperty('--eco-drawer-table-even', '#fff')
  el.style.setProperty('--eco-fixed-table-hover', '#e1e1e1')
  el.style.setProperty('--eco-fixed-table-active', '#E5F6FF')
  el.style.setProperty('--eco-room-title', '#555')
  el.style.setProperty('--eco-room-thead-title', '#787878')
  el.style.setProperty('--eco-room-tbody-title', '#787878')
  el.style.setProperty('--eco-room-table-bg', '#fafafa')
  el.style.setProperty('--eco-room-table-odd', '#fafafa')
  el.style.setProperty('--eco-room-table-even', '#fff')
  el.style.setProperty('--eco-capacity-table-even', '#EDEDED')
  el.style.setProperty('--eco-sharing-prompt-color', '#2A9ED7')

  el.style.setProperty('--hvac-date-list-select-tag-bg', '#334353')
  el.style.setProperty('--hvac-card-title-stress', '#0062CC')
  el.style.setProperty('--hvac-card-bg', '#2b3b4b')
  el.style.setProperty('--hvac-card-border', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--hvac-card-border-dashed', 'rgba(133, 150, 155, 0.3)')
  el.style.setProperty('--hvac-card-border-dark', 'rgba(133, 150, 155, 0.3)')
  el.style.setProperty('--hvac-card-border-light', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--hvac-card-border-op', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--hvac-card-border-op-2', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--hvac-card-border-op-3', 'rgba(63, 77, 90, 0.5)')
  el.style.setProperty('--hvac-disabled-text', 'rgba(85, 137, 155, 0.3)')
  el.style.setProperty('--hvac-calendar-today-bg', '#254251')
  el.style.setProperty('--hvac-header-btn-color', '#51646B')
  el.style.setProperty('--hvac-header-btn-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-header-btn-disabled-color', '#5AC8FA')
  el.style.setProperty('--hvac-header-btn-disabled-bg', '#2B3B4B')
  el.style.setProperty('--hvac-header-btn-icon-color', '#51646B')
  el.style.setProperty('--hvac-dialog-mask', 'rgba(0, 0, 0, 0.6)')
  el.style.setProperty('--hvac-iframe-bg', '#0C1216')
  el.style.setProperty('--hvac-btn-text-disabled', '#51646b')
  el.style.setProperty('--hvac-table-fixed-column-bg', '#2B3B4B')
  el.style.setProperty('--hvac-table-fixed-header-bg', '#263542')
  el.style.setProperty('--hvac-table-title-text', '#B9C1C4')
  el.style.setProperty('--hvac-table-header', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty(
    '--hvac-colunm-first',
    'radial-gradient(94.63% 94.63% at 50% 5.37%, #263743 0%, #000000 100%)'
  )
  el.style.setProperty('--hvac-row-all', '#254251')
  el.style.setProperty('--hvac-text-sum', '#C6E6F9')
  el.style.setProperty('--hvac-table-text-color', '#B9C1C4')
  el.style.setProperty('--hvac-table-even-color', 'rgba(0, 0, 0, 0.05)')
  el.style.setProperty('--hvac-table-border-color', '#51646B')
  el.style.setProperty('--hvac-header-border-bottom', '#C6E6F9')
  el.style.setProperty('--hvac-header-border-top', '#51646B')
  el.style.setProperty('--hvac-radio-color', '#85969B')
  el.style.setProperty('--hvac-title-body-bgColor', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--hvac-table-header-border', '#C6E6F9')
  el.style.setProperty('--hvac-card-header-bg', 'linear-gradient(180deg, #24313F 0%, #141B27 100%)')
  el.style.setProperty('--hvac-list-select-bg', '#2b3b4b')
  el.style.setProperty('--hvac-common-btn-border', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-common-btn-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-common-btn-color', '#B9C1C4')
  el.style.setProperty('--hvac-info-btn-bg', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-icon-light', '#B9C1C4')
  el.style.setProperty('--hvac-content-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--hvac-table-header-bg', 'rgba(95, 117, 162, 0.1)')
  el.style.setProperty('--hvac-table-header-color', '#85969B')
  el.style.setProperty('--hvac-table-body-tr-border', '#rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-icon-color', '#5AC8FA')
  el.style.setProperty('--hvac-dialog-subItem-bg', '#151D24')
  el.style.setProperty('--hvac-form-label-color', '#85969B')
  el.style.setProperty('--hvac-form-input-color', '#9FACB0')
  el.style.setProperty('--hvac-input-placeholder', '#51646B')
  el.style.setProperty('--hvac-icon-star', '#E53348')
  el.style.setProperty('--hvac-tab-border-color', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-btn-confirm-color', '#151D24')
  el.style.setProperty('--hvac-btn-confirm-bg', '#254251')
  el.style.setProperty('--hvac-btn-color', '#151D24')
  el.style.setProperty('--hvac-btn-bg', '#5AC8FA')
  el.style.setProperty('--hvac-btn-hover-color', '#5AC8FA')
  el.style.setProperty('--hvac-btn-hover-bg', '#254251')
  el.style.setProperty('--hvac-dialog-footer-bg', '#151D24')
  el.style.setProperty('--hvac-icon-disabled-color', '#254251')
  el.style.setProperty('--hvac-btn-add-color', '#151D24')
  el.style.setProperty('--hvac-table-body-cell-color', '#9FACB0')
  el.style.setProperty('--hvac-table-body-tr-odd', '#151D24')
  el.style.setProperty('--hvac-checkbox-inner-line', '#151D24')
  el.style.setProperty('--hvac-cascader-tag', '#2B3B4B')
  el.style.setProperty('--hvac-cascader-tag-color', '#B9C1C4')
  el.style.setProperty('--hvac-cascader-arrow-bg', '#17293C')
  el.style.setProperty('--hvac-cascader-menu-item-color', '#B9C1C4')
  el.style.setProperty('--hvac-cascader-menu-split-line', 'rgba(81, 100, 107, 0.6)')
  el.style.setProperty('--hvac-checkbox-inner-bg', 'transparent')
  el.style.setProperty('--hvac-scrollbar-thumb-bg', 'rgba(185, 193, 196, 0.4)')
  el.style.setProperty('--hvac-scrollbar-thumb-border', '#151D24')
  el.style.setProperty('--hvac-dialog-bg', '#17293C')
  el.style.setProperty('--hvac-dialog-shadow-color', 'rgba(21, 29, 36, 0.25)')
  el.style.setProperty('--hvac-dialog-shadow-header', 'transparent')
  el.style.setProperty('--hvac-popper-arrow-border-color', 'transparent')
  el.style.setProperty('--hvac-popper-text-color', '#151D24')
  el.style.setProperty('--hvac-popper-body-bg', '#B9C1C4')
  el.style.setProperty(
    '--hvac-search-wrapper-bg',
    'linear-gradient(180deg, #24313F 0%, #141B27 100%)'
  )
  el.style.setProperty('--hvac-switch_disabled_color', 'rgba(81, 100, 107, 0.4)')
  el.style.setProperty('--hvac-table-body-tr-border-color', '#51646B')
  el.style.setProperty('--hvac-el-tag-bg', 'rgba(21, 29, 36, 1)')
  el.style.setProperty('--hvac-upload-drag-hover', '#2B3B4B')
  el.style.setProperty('--hvac-upload-drag-format-error', '#591C20')
  el.style.setProperty('--hvac-upload-drag-format-error-span', '#E53348')
  el.style.setProperty('--hvac-item-active-label', '#5AC8FA')
  el.style.setProperty('--hvac-item-active-border', '#5AC8FA')
  el.style.setProperty('--hvac-batch-import-success', '#33C733')
  el.style.setProperty('--hvac-btn-cancel', 'rgba(81, 100, 107, 0.40)')
  el.style.setProperty('--hvac-orange-value-color', '#FF9300')
  el.style.setProperty('--hvac-blue-value-color', '#64C9FA')
  el.style.setProperty('--hvac-green-value-color', '#33C733')
  el.style.setProperty('--hvac-red-value-color', '#E53348')
}
/**
 * Subtracts the indicated percentage to the R, G or B of a HEX color
 * @param {string} color The color to change
 * @param {number} amount The amount to change the color by
 * @returns {string} The processed part of the color
 */
const subtractLight = (color: string, amount: number) => {
  const cc = parseInt(color, 16) - amount
  const c = cc < 0 ? 0 : cc
  return c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
}
